var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{attrs:{"size":"small"}},[_c('div',{staticClass:"col-span-full"},[(_vm.messages.length)?_c('KeyMessage',{attrs:{"messages":_vm.messages}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }